import React from 'react';
import { Box, Grid2 as Grid, Typography, IconButton, Link, useMediaQuery, useTheme } from '@mui/material';
import './footer.css';

import LogoMobile from "../../assets/images/Logo_Marian.png";
import LogoDesktop from "../../assets/images/Logo_Marian.svg";

import FacebookIcon from '@mui/icons-material/FacebookRounded';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useCurrentBreakpoint } from '../../utils/breakpoints';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const handleClick = (url) => {
    window.open(url, '_blank');
  };
  const theme = useTheme();
  const currentBreakpoint = useCurrentBreakpoint();
  const iconSize = currentBreakpoint === "mobile" ? "medium" : "large";
  const isMobile = useMediaQuery(theme.breakpoints.down(700));
  const Logo = isMobile ? LogoMobile : LogoDesktop;
  return (
    <Box className="footer-container">
      <Grid container justifyContent="space-between" alignItems="center" className="footer-content">
        {/* Logo y texto izquierdo */}
        <Grid container spacing={4} className="footer-logo">
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Link to="/">
              <img src={Logo} alt="Logo Marián" className="header-logo" />
            </Link>
            <Typography variant="body2" className="text-author">
              © 2025 todos los derechos reservados
            </Typography>
          </Box>
        </Grid>

        {/* Redes sociales y enlaces */}
        <Grid container spacing={4} className="footer-social">
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Box className="social-icons">
              <IconButton className="social-icon" onClick={() => handleClick('https://www.facebook.com/MarianGalletas')} >
                <FacebookIcon fontSize={iconSize} />
              </IconButton>
              <IconButton className="social-icon" onClick={() => handleClick('https://www.instagram.com/galletasmarian/')} >
                <InstagramIcon fontSize={iconSize} />
              </IconButton>
            </Box>
            <Box sx={{ display: "flex", gap: "30px", marginTop: "15px" }}>
              <Typography variant="body2" className="text-author" sx={{ cursor: "pointer", textDecoration: "none", color: "inherit", '&:hover': { textDecoration: "underline" } }} component={Link} to="/avisoprivacidad" target="_blank"
    rel="noopener noreferrer" onClick={() => navigate('/avisoprivacidad')}>
                Política de Privacidad
              </Typography>
              <Typography variant="body2" className="text-author" sx={{ cursor: "pointer" }} onClick={() => navigate('/contacto')}>
                Contáctanos
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Footer;
